__turbopack_context__.v({
  "container": "r1pGpq_container",
});
